import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  Modal,
  Checkbox,
  Typography,
  TextField,
} from "@mui/material";
import ButtonsComponent from "../components/homePageCompo/tabComponents/ButtonsComponent";
import FilterComponent from "../components/homePageCompo/FilterComponent";
import ScanAndRouteButtons from "../components/homePageCompo/ScanAndRouteButtons";
import OrderDetails from "../components/homePageCompo/OrderDetails/OrderDetails";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { v4 as uuidv4 } from "uuid";
import { postApiWithAuth, putApiWithAuth } from "../utils/api";
import {
  FCM_TOKEN,
  UNSEEN_NOTIFICATION_LIST,
  AUTH_ME,
  MARK_SEEN,
  TWILIO_UNREAD_SMS_COUNT,
  UPDATE_BULK_STATUS,
  CANCEL_ORDER_WITH_NOTE,
} from "../utils/apiUrl";
import AnnouncementPopup from "../components/Ui/AnnouncementPopup";
import { getApiWithAuth } from "../utils/api";
import { toast } from "react-toastify";
const HomePage = () => {
  const userId = localStorage.getItem("UID");
  const [filterData, setFilterData] = useState(null);
  const [orders, setOrders] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  const [selectedOrderDetails, setSelectedOrderDetail] = useState([]);
  const [currentCancelIndex, setCurrentCancelIndex] = useState(0);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [cancelNote, setCancelNote] = useState(false);
  const [buttonData, setButtonData] = useState(null);
  const [userDetail, setUserDetail] = useState(null);
  const [popupOpen, setPopupOpen] = useState(true);
  const [response, setResponse] = useState("");
  const [selectedTab, setSelectedTab] = useState("all");
  const userType = localStorage.getItem("userType");
  const fetchOrdersRef = useRef();
  const handledNotifications = useRef(new Set());
  const [status, setStatus] = useState(
    userType === "PharmacyOwner" || userType === "PharmacyEmployee"
      ? "3"
      : "all"
  );
  const [label, setLabel] = useState();
  const [unreadCounts, setUnreadCounts] = useState({});

  const [transitOpen, setTransitOpen] = useState();
  const scrollContainerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [moveCheck, setMoveCheck] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  const [triggerFilterFetch, setTriggerFilterFetch] = useState(false);

  const firebaseConfig = {
    apiKey: "AIzaSyACIeDtvL3fE__Cmvx3XHUZ9PaEQGDz6xk",
    authDomain: "pilldrop-e5ee9.firebaseapp.com",
    projectId: "pilldrop-e5ee9",
    storageBucket: "pilldrop-e5ee9.appspot.com",
    messagingSenderId: "393895297538",
    appId: "1:393895297538:web:69f0761a352f36d4a09d1b",
    measurementId: "G-SJB9HDV4M5",
  };

  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);

  function requestPermission() {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        const messaging = getMessaging(app);
        getToken(messaging, {
          vapidKey:
            "BEemXXGaQ8Lc8GuuWT8YAlESr2Wia9jaVBpwiZpgq1HBrFTSCr2cp7mKByjgBqnV38zIZBnHbr5pjIUAJy0fF1k",
        }).then((currentToken) => {
          if (currentToken) {
            sendTokenToBackend(currentToken);
          } else {
            console.log("Can't get token");
          }
        });
      } else {
        console.log("Don't have permission");
      }
    });
  }

  const handleOrderSelection = (orderId) => {
    if (selectedOrderIds.includes(orderId.id)) {
      setSelectedOrderIds(selectedOrderIds.filter((id) => id !== orderId.id));
      setSelectedOrderDetail(
        selectedOrderDetails.filter((order) => order !== orderId)
      );
    } else {
      setSelectedOrderIds([...selectedOrderIds, orderId.id]);
      setSelectedOrderDetail([...selectedOrderDetails, orderId]);
    }
  };

  const handleMoveCheck = () => {
    setMoveCheck(!moveCheck);
  };

  function handleBulkCancel() {
    setCurrentCancelIndex(0);
    setCancelOpen(true);
  }

  const handleSelectAllOrders = () => {
    setSelectAll(!selectAll);
    if (selectAll) {
      setSelectedOrderIds([]);
      setSelectedOrderDetail([]);
    } else {
      if (
        selectedTab.label === "Dispatching" ||
        selectedTab.label === "In Transit" ||
        selectedTab.label === "Route Created" ||
        selectedTab.label === "Failed" ||
        selectedTab.label === "Out for Delivery"
      ) {
        setSelectedOrderIds(
          orders
            ?.filter((order) => order.status === "4")
            .map((order) => order.id)
        );
      } else {
        setSelectedOrderIds(
          orders
            ?.filter((order) => order.status === "3")
            .map((order) => order.id)
        );
      }
    }
  };

  const sendTokenToBackend = async (token) => {
    try {
      // Check if token has already been added
      const tokenAdded = localStorage.getItem("tokenAdded");

      if (tokenAdded === "true") {
        return;
      }

      const user_id = localStorage.getItem("UID");
      const pharmacyId = localStorage.getItem("pharmacyId");
      let deviceId = localStorage.getItem("deviceId");

      // If device ID doesn't exist, generate a new one
      if (!deviceId) {
        deviceId = uuidv4();
        localStorage.setItem("deviceId", deviceId);
      }

      const response = await postApiWithAuth(FCM_TOKEN, {
        token,
        user_id,
        pharmacyId,
        deviceId,
      });

      // If token was successfully sent to the backend, set tokenAdded to true
      if (response.data.status === 200 || response.data.status === 201) {
        localStorage.setItem("tokenAdded", "true");
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const handleConfirmCancel = async () => {
    const { id } = selectedOrderDetails[currentCancelIndex];
    try {
      const response = await putApiWithAuth(`${CANCEL_ORDER_WITH_NOTE}${id}`, {
        note: cancelNote,
      });

      console.log(response);

      setCancelNote("");

      const next = currentCancelIndex + 1;
      if (next < selectedOrderDetails.length) {
        setCurrentCancelIndex(next);
      } else {
        setCancelOpen(false);
        setSelectedOrderDetail([]);
        setSelectedOrderIds([]);
        setCurrentCancelIndex(0);
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const fetchAuthUserDetail = async () => {
    const response = await getApiWithAuth(AUTH_ME);
    if (response && response.data) {
      setUserDetail(response.data.data.data);
    }
  };

  useEffect(() => {
    fetchAuthUserDetail();
  }, []);

  useEffect(() => {
    requestPermission();

    const unsubscribe = onMessage(messaging, (payload) => {
      const notificationId = payload.messageId;
      if (handledNotifications.current.has(notificationId)) {
        return;
      }
      handledNotifications.current.add(notificationId);

      const { title, body, icon, image } = payload.notification;
      const notificationIcon =
        icon || "https://www.test.pilldrop.ai/logo192.png";
      const notificationImage = image;

      const notificationOptions = {
        body,
        icon: notificationIcon,
        image: notificationImage,
        data: {
          url: payload.data?.openUrl || "https://www.pilldrop.ai",
        },
      };

      const notification = new Notification(title, notificationOptions);

      notification.onclick = (event) => {
        event.preventDefault();
        const url = notificationOptions.data.url;
        if (url) {
          window.open(url, "_blank");
        }
      };
    });
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const userType = localStorage.getItem("userType"); // Get user type from localStorage

        if (userType === "PharmacyOwner" || userType === "PharmacyEmployee") {
          const response = await getApiWithAuth(UNSEEN_NOTIFICATION_LIST);

          if (response && Array.isArray(response.data.data)) {
            setNotifications(response.data.data);
          } else {
            console.error("Unexpected data format:", response);
          }
        }
      } catch (err) {
        console.error("Error fetching notifications:", err);
        toast.error("Failed to fetch notifications.");
      }
    };

    fetchNotifications();
  }, []);
  const fetchUnreadSmsCount = async () => {
    const response = await getApiWithAuth(TWILIO_UNREAD_SMS_COUNT);
    const data = response.data.data;
    setUnreadCounts(data.unread_counts);
  };

  useEffect(() => {
    fetchUnreadSmsCount();
  }, []);

  const handleFilterData = (data) => {
    setFilterData(data);
  };

  const handleOrderData = (data) => {
    setOrders(data);
  };

  const markReadOrderChat = (id) => {
    console.log(id);
  };

  const handleButtonValue = (button) => {
    setButtonData(button);
    setSelectedTab(button);
  };

  const handleStatusValue = (status, label, transitOpen) => {
    setStatus(status);
    setLabel(label);
    setTransitOpen(transitOpen);
    setSelectedTab({ label: label });
  };

  const handleScroll = () => {
    if (!scrollContainerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } =
      scrollContainerRef.current;

    // Check if scrolled to the bottom
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      if (!isLoading) {
        setIsLoading(true);
        fetchOrdersRef.current(true);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [isLoading]);

  const handleOpenPopup = () => {
    setPopupOpen(true);
  };
  const handleMarkSeen = async (notification_id) => {
    if (notification_id) {
      const colorFormData = new FormData();
      colorFormData.append("notification_id", notification_id);
      colorFormData.append("user_id", userId);
      try {
        const colorResponse = await postApiWithAuth(MARK_SEEN, colorFormData);
        if (colorResponse.data) {
          console.log("Mark read successfully");
        } else {
          console.log("Failed to update", colorResponse);
        }
      } catch (error) {
        console.error("Error updating:", error);
      }
    }
  };
  // Function to close the popup
  const handleClosePopup = (notification_id) => {
    setPopupOpen(false);
    handleMarkSeen(notification_id); // Pass the notification_id
  };

  const handleSubmitResponse = (userInput) => {
    setResponse(userInput); // Save the response in state
  };

  const handleMoveDispatch = async () => {
    console.log("selcted tab here",selectedTab);
const statusMap = {
  "Dispatching": "4",
  "Route Created": "4",
  "Failed": "4",
  "Out for Delivery": "4",
  "Created Orders": "3",
  "In Transit": "4", // Adjust if needed
};

const currentStatus = statusMap[selectedTab.label] || "4";
const movedStatus = currentStatus === "3" ? "4" : "3";

// Always determine labelAccordStatus based on label
let labelAccordStatus = null;
if (selectedTab.label === "Route Created") {
  labelAccordStatus = "7";
} else if (selectedTab.label == "Failed") {
  labelAccordStatus = "8";
} else if (selectedTab.label === "Out for Delivery") {
  labelAccordStatus = "9";
} else if (selectedTab.label === "Dispatching") {
  labelAccordStatus = "4";
} else if (selectedTab.label === "In Transit") {
  labelAccordStatus = "7all";
}

try {
  const payload = {
    orderIds: selectedOrderIds,
    currentStatus,
    movedStatus,
    isAll: selectAll,
  };

  if (labelAccordStatus) {
    payload.labelAccordStatus = labelAccordStatus;
  }

  const moveOrderResponse = await postApiWithAuth(UPDATE_BULK_STATUS, payload);
  console.log(moveOrderResponse);
      if (moveOrderResponse.data.status === 200) {
        if (
          selectedTab.label === "Dispatching" ||
          selectedTab.label === "In Transit" ||
          selectedTab.label === "Route Created" ||
          selectedTab.label === "Failed" ||
          selectedTab.label === "Out for Delivery"
        ) {
          toast.success(`Order returned to created successfully!`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          handleStatusValue("3", "Created Orders", false);
        } else {
          toast.success(`Order moved to dispatch successfully!`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          handleStatusValue("4", "Dispatching", true);
        }
      } else {
        toast.error(`Backend Error!`, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        handleStatusValue("4", "Dispatching", true);
      }
    } catch (error) {
      toast.error(`An error occurred while merging routes!`, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      handleStatusValue("4", "Dispatching", true);
    }
    setSelectedOrderIds([]);
  };

  const cancelOrderDetail = selectedOrderDetails[currentCancelIndex] || {};

  function handleSkip() {
    const next = currentCancelIndex + 1;

    if (next < selectedOrderDetails.length) {
      setCurrentCancelIndex(next);
    } else {
      setCancelOpen(false);
      setSelectedOrderDetail([]);
      setSelectedOrderIds([]);
      setCurrentCancelIndex(0);
    }
  }

  return (
    <>
      <Box
        ref={scrollContainerRef}
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "40px",
          minWidth: "100%",
          minHeight: "80vh",
          maxHeight: "100vh",
          overflowY: "auto",
          "@media (max-width: 1500px)": {
            minWidth: "1400px",
          },
        }}
      >
        <ButtonsComponent
          filterData={filterData}
          onButtonClick={handleButtonValue}
          fetchorders={() => fetchOrdersRef.current()}
          label={label}
          transitOpen={transitOpen}
        />
        <FilterComponent
          onFilterData={handleFilterData}
          onOrderData={handleOrderData}
          buttonData={buttonData}
          // markReadOrderChatMain={markReadOrderChatMain}
          statuschild={status}
          fetchOrdersRef={fetchOrdersRef}
          triggerFetch={triggerFilterFetch}
          resetTrigger={() => setTriggerFilterFetch(false)}
          handleMoveCheck={handleMoveCheck}
          handleMoveDispatch={handleMoveDispatch}
          handleBulkCancel={handleBulkCancel}
          moveCheck={moveCheck}
          selectAll={selectAll}
          handleSelectAllOrders={handleSelectAllOrders}
        />
        {notifications.length > 0 &&
          notifications.map((notification) => (
            <AnnouncementPopup
              key={notification.notification_id}
              open={popupOpen}
              title={notification.heading}
              description={notification.description}
              onClose={() => handleClosePopup(notification.notification_id)} // Pass the notification_id here
              onSubmit={handleSubmitResponse}
            />
          ))}
        {orders?.map((order, index) => (
          <Box
            key={index}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            {moveCheck && (
              <Checkbox
                autoComplete="off"
                type="checkbox"
                checked={selectedOrderIds.includes(order.id)}
                onChange={() => handleOrderSelection(order)}
                style={{ transform: "scale(0.8)" }}
              />
            )}
            <OrderDetails
              key={order.id || index}
              showTicket={order.last_orderticket !== null}
              showUrgent={order.deliverydate === "Urgent"}
              showphotoId={order.photoid}
              showRefrigerated={order.refrigrated}
              order={order}
              fetchorders={() => fetchOrdersRef.current()}
              userDetail={userDetail}
              markReadOrderChat={markReadOrderChat}
              unreadCounts={unreadCounts?.[order?.id] || 0}
              handleMoveCheck={handleMoveCheck}
            />
          </Box>
        ))}
      </Box>
      <ScanAndRouteButtons
        onstatusChange={handleStatusValue}
        selectedTab={selectedTab}
        onSuccess={() => setTriggerFilterFetch(true)}
      />

      {/* Cancel Model */}
      <Modal open={cancelOpen} onClose={() => handleSkip()}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "background.paper",
            p: 3,
            borderRadius: 3,
            boxShadow: 3,
            textAlign: "left",
            background: "linear-gradient(to bottom, #f8fcff, #fff6f6)",
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold" color="#2c64a7">
            Cancel Order
          </Typography>

          <Typography>Order ID: {cancelOrderDetail.id}</Typography>
          <Typography>Order Name: {cancelOrderDetail.name}</Typography>
          <Typography variant="h6" sx={{ fontSize: "12px", color: "#0b6699" }}>
            Cancel Notes
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            autoComplete="off"
            // placeholder="To Add or Remove Any Staff Notes. If Note is Cleared and Saved Then Blue Highlight Will Be Removed."
            multiline
            rows={3}
            value={cancelNote}
            onChange={(e) => setCancelNote(e.target.value)}
            sx={{
              mb: 2,
            }}
            InputProps={{
              sx: {
                padding: "6px",
                "& .MuiInputBase-input": {
                  padding: "6px",
                  fontSize: "11px",
                  fontWeight: 500,
                  lineHeight: "1.2",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid black",
                  borderRadius: "6px",
                },
              },
            }}
          />
          <Box
            sx={{ display: "flex", gap: 1, mt: 3, justifyContent: "flex-end" }}
          >
            <Button
              variant="outlined"
              onClick={handleSkip}
              sx={{
                textTransform: "none",
                px: 3,
                borderRadius: "8px",
                borderColor: "#D0D5DD",
                color: "#344054",
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: "#F9FAFB",
                  borderColor: "#D0D5DD",
                },
              }}
            >
              Cancel
            </Button>

            <Button
              variant="outlined"
              onClick={() => handleConfirmCancel()}
              sx={{
                textTransform: "none",
                px: 3,
                borderRadius: "8px",
                borderColor: "#D0D5DD",
                color: "#344054",
                backgroundColor: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#F9FAFB",
                  borderColor: "#D0D5DD",
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default HomePage;
